import "./utils/modernizr";

import React from "react";
import ReactDOM from "react-dom";
import App from "./views/layouts/app";
import * as serviceWorker from "./serviceWorker";
// style
import "./styles/main.scss";

import { Provider as ReduxProvider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <Router>
        <App />
      </Router>
    </ReduxProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
